import React, { useEffect } from "react";
import { PrefillSelect } from "@components/input";
import { useFormikContext } from "formik";
import { isNotNullOrEmpty } from "@utils/helpers/stringHelper";
import { useSelector } from "react-redux";
import { FIELD_NAMES, LOAN_REASONS, PRODUCT_TYPE } from "../../../../constants/commonConstants";
import { useRequestedProductType } from "@hooks";
import { createOption } from "../../../../constants/options";

const fieldName = "requestedProductType";

// ensures that autofill hasn't placed in an invalid value, this could be re-worked to work with
// any dropdown in the future (just extract requestedProductType AND productTypeValues as params)
const useHandleInvalidLoanTypes = (productTypeValues) => {
  const requestedProductType = useRequestedProductType();
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    const resetField = () => setFieldValue(fieldName, "");
    const fieldContainsInvalidLoanType =
      isNotNullOrEmpty(requestedProductType) && !productTypeValues.includes(requestedProductType);

    if (fieldContainsInvalidLoanType) {
      resetField();
    }
  }, [requestedProductType, setFieldValue]);
};

const name = "requestedProductType";

const useCalculateDefaultProductType = () => {
  const { sanitizedQuerystring } = useSelector((state) => state.loanForm);
  const { [FIELD_NAMES.LOAN_REASON]: loanReason, [FIELD_NAMES.LOAN_AMOUNT]: loanAmount } = sanitizedQuerystring;

  if (loanReason === LOAN_REASONS.VEHICLE_PURCHASE && loanAmount >= 5000) {
    return PRODUCT_TYPE.CAR_LOAN;
  }

  return PRODUCT_TYPE.PERSONAL_LOAN;
};

const RequestedProductType = () => {
  let { loanReasonsResponse } = useSelector(state => state.StartUp);
  loanReasonsResponse = loanReasonsResponse || [];

  const productTypeValues = loanReasonsResponse.map((data) => data.type);
  useHandleInvalidLoanTypes(productTypeValues);
  
  const defaultValue = useCalculateDefaultProductType();
  let productTypeOptions = [];

  if (isNotNullOrEmpty(loanReasonsResponse)) {
    loanReasonsResponse.map((data) => {
      productTypeOptions.push(createOption(data.name, data.type));
    });
  }

  return (
    <PrefillSelect
      name={name}
      title="Loan Type"
      defaultValue={defaultValue}
      options={productTypeOptions}
      placeholder="Select loan type..."
      context={loanReasonsResponse}
    />
  );
}

export default RequestedProductType;